import Vue from 'vue';
import VueRouter, { Route, RouteConfig } from 'vue-router';

Vue.use(VueRouter);

import store from '@/store';
import { HEARD_FROM, MINORS, PERSON, PLAYER, SELECTED_RESERVATION } from '@/store/state';
import ConfirmPerson from '@/components/ConfirmPerson.vue';
import Contract from '@/components/Waiver/Contract.vue';
import Guardian from '@/components/Waiver/Guardian.vue';
import Home from '@/views/Home.vue';
import Waiver from '@/views/Waiver.vue';
import Landing from '@/components/Landing.vue';
import PersonDetails from '@/components/Waiver/PersonDetails.vue';
import Promotion from '@/components/Waiver/Promotion.vue';
import FollowUpSurvey from '@/components/Waiver/FollowUpSurvey.vue';
import Success from '@/views/Success.vue';

import Gamebay from '@/views/Gamebay.vue';
import Waiverlink from '@/views/Wronglink.vue';
import CancelledReservation from '@/views/CancelledReservation.vue';


export const WaiverRouteChildren = [
  {
    path: 'person/:id?',
    name: 'PersonDetails',
    component: PersonDetails,
    // TODO: what happens when we come from a xola id?
    props: (route: Route) => ({ person: store.state[PERSON], player: store.state[PLAYER] }),
  },
  {
    path: 'promotion',
    name: 'Promotion',
    component: Promotion,
    props: (route: Route) => ({ heardFrom: store.state[HEARD_FROM] }),
    // beforeEnter (to, from, next) {
    //   console.log('Promotion PERSON', store.state[PERSON])
    //   if (!store.state[PERSON]) next({ name: 'PersonDetails' })
    //   else next()
    // }
  },
  {
    path: 'follow-up-survey',
    name: 'FollowUpSurvey',
    component: FollowUpSurvey,
  },
  {
    path: 'guardian',
    name: 'Guardian',
    component: Guardian,
    props: (route: Route) => ({ 
      guardian: !!store.state[MINORS]?.length,
      minors: store.state[MINORS]
    }),
    beforeEnter (to, from, next) {
      if (!store.state[SELECTED_RESERVATION]) next({ name: 'FindReservation' })
      else next()
    }
  },
  {
    path: 'contract',
    name: 'Contract',
    component: Contract,
  },
] as RouteConfig[]

const routes: RouteConfig[] = [

  { path : '/gamebay', component: Gamebay},
  { path : '/link', component: Waiverlink},
  { path : '/cancelled', component: CancelledReservation},


  {
    path: '/success',
    name: 'Success',
    component: Success,
    props: (route: Route) => ({
      onComplete: ($router: VueRouter) => { 
        $router.replace({ name: 'Home' })
        location.reload()
      }
    })
  },
  {
    path: '/waiver',
    name: 'Waiver',
    // component: () => import(/* webpackChunkName: "waiver" */ '../views/Waiver.vue'),
    component: Waiver,
    children: WaiverRouteChildren,
    beforeEnter (to, from, next) {
      if (!store.state[SELECTED_RESERVATION]) next({ name: 'FindReservation' })
      else next();
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'find',
        name: 'FindReservation',
        component: Landing
      },
      {
        path: 'confirm',
        name: 'Confirm',
        component: ConfirmPerson,
        beforeEnter (to, from, next) {
          if (!store.state[SELECTED_RESERVATION]) next({ name: 'FindReservation' });
          else next();
        }
      },
    ]
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

export default router;
